import {
  classNamesFunction,
  IProcessedStyleSet,
  IStyle,
  IStyleFunctionOrObject,
  IStyleSet,
  styled
} from 'office-ui-fabric-react';
import * as React from 'react';

import { IThemedProp } from './theme';

/**
 * A components that is wrapped by `styledComponent` should have those props
 */
export interface IStyledComponent<TStyleSet, TStyleProps extends IThemedProp = IThemedProp> extends IThemedProp {
  // @ts-ignore TODO: TS Bug, remove once upgrade
  styles: IStyleFunctionOrObject<TStyleProps, TStyleSet>;
}

/**
 * This function returns a function that produces classnames
 */
export function getClassNamesFunction<
  TStyleSet extends IStyleSet<TStyleSet>,
  TStyleProps extends IThemedProp = IThemedProp
>(): (
  getStyles: IStyleFunctionOrObject<TStyleProps, TStyleSet> | undefined,
  styleProps?: TStyleProps
) => IProcessedStyleSet<TStyleSet> {
  return classNamesFunction<TStyleProps, TStyleSet>();
}

export type SubStyle<T> = Partial<NonNullable<T>> & { [key: string]: IStyle };

/**
 * A HOC that wraps a component and decorate it with styles.
 *
 * This should go inside mconnect() if needed
 * @param Component The component being wrapped
 * @param styleFunction The style function for the component
 */
export function styledComponent<
  TComponentProps extends IStyledComponent<TStyleSet, TStyleProps>,
  TStyleSet extends IStyleSet<TStyleSet>,
  TStyleProps extends IThemedProp = IThemedProp,
  RProps = Pick<TComponentProps, Exclude<keyof TComponentProps, 'theme' | 'styles'>> &
    Partial<Pick<TComponentProps, 'styles'>>
>(
  Component: React.ComponentClass<TComponentProps> | React.FC<TComponentProps>,
  styleFunction: IStyleFunctionOrObject<TStyleProps, TStyleSet>
): React.ComponentClass<RProps, never> {
  // tslint:disable-next-line: ban
  return (styled<TComponentProps, TStyleProps, TStyleSet>(
    Component,
    styleFunction,
    undefined,
    undefined,
    true
  ) as unknown) as React.ComponentClass<RProps, never>;
}
